import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/app.css";
import { initAnalytics, track } from "./services/analytics";

initAnalytics();

// If a fatal error escapes React entirely, never leave a blank screen.
window.addEventListener("error", (e) => {
  const root = document.getElementById("root");
  if (root && root.childElementCount === 0) {
    root.innerHTML =
      '<div style="padding:40px 20px;font-family:sans-serif;text-align:center">' +
      "<h2>Something went wrong</h2><p style=\"color:#52657f;font-size:13px\">" +
      String(e.message) +
      '</p><button style="min-height:52px;padding:0 24px;background:#1769e8;color:#fff;border:none;border-radius:14px;font-size:16px" onclick="location.href=\'/\'">Reload app</button></div>';
  }
});

// QR landing: packaging QR points at viraball.com/start which redirects
// here with ?src=qr (configure the redirect to append it).
if (new URLSearchParams(window.location.search).get("src") === "qr") {
  track("qr_landing_opened");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
